<script>
	/*
		TCareCheckBox.svelte

		Contains the box and the label.

		10/5 - moved the pushing and removing logic here
	*/

	export let source;
	export let prop;
	export let setValue;
	export let value;
	export let label;

	// determined differently since question.value is an array
	$: isSelected = source[prop] ? source[prop].includes(value) : false;

	const _onClick = () => {
		if (!source[prop]) source[prop] = [];
		if (isSelected) {
			source[prop] = source[prop].filter(el => el !== value)
        } else {
			source[prop].push(value);            
		}

		// still need to call this  for refresh
		setValue(source, prop, source[prop]);
	}

</script>

<style>
</style>

<div class="tcui-control flex-row check-box" on:click={_onClick}>
	{#if isSelected}
		<div class="outer flex-center selected">
			<div class="inner"></div>
		</div>
	{:else}
		<div class="outer flex-center"></div>
	{/if}
	<div class="label">{label}</div>
</div>

